import { AgGridReact } from 'ag-grid-react';
import type { ColDef, RowClickedEvent } from 'ag-grid-community';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

// AG Grid TR localization — görünür UI etiketleri
const agGridTrLocale: Record<string, string> = {
  // Filtre paneli
  filterOoo: 'Filtrele...',
  equals: 'Eşit',
  notEqual: 'Eşit değil',
  contains: 'İçerir',
  notContains: 'İçermez',
  startsWith: 'İle başlar',
  endsWith: 'İle biter',
  blank: 'Boş',
  notBlank: 'Dolu',
  lessThan: 'Küçüktür',
  greaterThan: 'Büyüktür',
  lessThanOrEqual: 'Küçük eşittir',
  greaterThanOrEqual: 'Büyük eşittir',
  inRange: 'Aralık',
  inRangeStart: 'Başlangıç',
  inRangeEnd: 'Bitiş',
  searchOoo: 'Ara...',
  selectAll: '(Tümünü Seç)',
  selectAllSearchResults: '(Arama Sonuçlarını Seç)',
  noMatches: 'Eşleşme yok',
  applyFilter: 'Uygula',
  resetFilter: 'Sıfırla',
  clearFilter: 'Temizle',
  cancelFilter: 'İptal',
  textFilter: 'Metin Filtresi',
  numberFilter: 'Sayı Filtresi',
  dateFilter: 'Tarih Filtresi',
  // Sütun menüsü
  pinColumn: 'Sütunu Sabitle',
  pinLeft: 'Sola Sabitle',
  pinRight: 'Sağa Sabitle',
  noPin: 'Sabitleme Yok',
  autosizeThiscolumn: 'Bu Sütunu Otomatik Boyutla',
  autosizeAllColumns: 'Tüm Sütunları Otomatik Boyutla',
  resetColumns: 'Sütunları Sıfırla',
  // Pagination
  page: 'Sayfa',
  more: 'Daha fazla',
  to: '/',
  of: '—',
  next: 'Sonraki',
  last: 'Son',
  first: 'İlk',
  previous: 'Önceki',
  pageSizeSelectorLabel: 'Sayfa boyutu:',
  // Status
  loadingOoo: 'Yükleniyor...',
  noRowsToShow: 'Gösterilecek satır yok',
  // Sıralama
  sortAscending: 'Artan Sırala',
  sortDescending: 'Azalan Sırala',
  sortUnSort: 'Sıralamayı Kaldır',
};

interface DataGridProps<T> {
  data: T[];
  columns: ColDef<T>[];
  loading?: boolean;
  height?: number | string;
  onRowClick?: (data: T) => void;
  pagination?: boolean;
  pageSize?: number;
}

export function DataGrid<T>({
  data,
  columns,
  loading = false,
  height = 500,
  onRowClick,
  pagination = true,
  pageSize = 50,
}: DataGridProps<T>) {
  const handleRowClicked = (event: RowClickedEvent<T>) => {
    if (onRowClick && event.data) {
      onRowClick(event.data);
    }
  };

  return (
    <div className="ag-theme-alpine" style={{ height, width: '100%' }}>
      <AgGridReact<T>
        rowData={data}
        columnDefs={columns}
        loading={loading}
        pagination={pagination}
        paginationPageSize={pageSize}
        paginationPageSizeSelector={[20, 50, 100, 200]}
        onRowClicked={handleRowClicked}
        defaultColDef={{
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 80,
        }}
        animateRows={false}
        rowSelection="single"
        suppressCellFocus
        enableCellTextSelection
        localeText={agGridTrLocale}
      />
    </div>
  );
}
